'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizeUrl = require('normalize-url');

var _normalizeUrl2 = _interopRequireDefault(_normalizeUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isString = function isString(string) {
  return typeof string === 'string';
};
var hasHTTPProtocol = function hasHTTPProtocol(url) {
  return isString(url) && url.startsWith('http');
};

var appendURL = function appendURL() {
  for (var _len = arguments.length, pieces = Array(_len), _key = 0; _key < _len; _key++) {
    pieces[_key] = arguments[_key];
  }

  return pieces.reduce(function (acc, current) {
    if (Array.isArray(current)) {
      return acc + appendURL.apply(undefined, current);
    }

    if (hasHTTPProtocol(current)) {
      return current;
    }

    return acc + '/' + current;
  }, '');
};

exports.default = function () {
  for (var _len2 = arguments.length, pieces = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    pieces[_key2] = arguments[_key2];
  }

  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, _normalizeUrl2.default)(appendURL(pieces) + '/', { removeTrailingSlash: options.removeTrailingSlash });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/utils/normalize-url.js
// module id = 586
// module chunks = 0